import { Classic } from "./Classic/Classic";
import { Modern } from "./Modern/Modern";

export const Themes = {
  Classic,
  Modern,
};
